import { createStyles, makeStyles } from "@mui/styles";
import { inputStyles } from "components/FormControls/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      width: "100%",
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
    Paper: {
      display: "flex",
      flexWrap: "wrap",
      marginTop: theme.spacing(8),
      padding: theme.spacing(10),
    },
    ItemType: {
      maxWidth: "100%",
      padding: theme.spacing(6),
    },
    grayText: {
      color: theme.gray500,
      display: "block",
      fontSize: 18,
      margin: theme.spacing(12, 0, 8),
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
    displayColumn: { flexDirection: "column" },
    button: {
      display: "block",
      margin: theme.spacing(12, 0, 16, "auto"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    grid: {
      alignItems: "center",
      marginTop: theme.spacing(5),
      [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(0),
      },
    },
    modalInput: {
      maxWidth: "100%",
      width: 406,
      "& + &": { marginTop: theme.spacing(10) },
    },
    modalButton: {
      height: theme.spacing(24),
      marginTop: theme.spacing(12),
    },
    mainTitle: {
      marginTop: 0,
    },
    input: {
      width: "100%",
      ...inputStyles,
    },
    sectionHeaderContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontSize: "16px",
      fontWeight: 500,
      color: "#222222",
    },
    infoIcon: {
      color: theme.gray500,
    },
    tooltipTitle: {
      fontWeight: 500,
      fontSize: 14,
      color: theme.black,
      lineHeight: "24px",
      marginBottom: theme.spacing(2),
    },
    tooltipDesc: {
      color: theme.gray500,
      fontSize: 12,
      fontWeigh: 400,
      lineHeight: "20px",
    },
    questionMarkIcon: {
      color: theme.gray500,
      width: 14,
      height: 14,
      marginLeft: theme.spacing(4),
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
    },
    clearIcon: {
      cursor: "pointer",
    },
    icon: {
      color: theme.gray500,
      marginLeft: theme.spacing(2),
    },
  }),
);
